import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { appNavigation, urlMap } from '../../utils';

function getQueryParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

class AdminVerifyUser extends Component {
  state = {
    status: 'loading', // loading | success | already | expired | invalid | error
    email: '',
  };

  async componentDidMount() {
    const token = getQueryParam('token') || '';
    const email = (getQueryParam('email') || '').toLowerCase();

    this.setState({ email });

    if (!token || !email) {
      this.setState({ status: 'invalid' });
      return;
    }

    try {
      const res = await fetch(urlMap.adminVerify, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, email }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        if (data.status === 'already-verified') {
          this.setState({ status: 'already' });
          return;
        }
        this.setState({ status: 'success' });
        return;
      }

      if (res.status === 410 || data.error === 'EXPIRED') {
        this.setState({ status: 'expired' });
        return;
      }

      if (res.status === 400 || data.error === 'INVALID' || data.error === 'MISSING_TOKEN_OR_EMAIL') {
        this.setState({ status: 'invalid' });
        return;
      }

      this.setState({ status: 'error' });
    } catch {
      this.setState({ status: 'error' });
    }
  }

  renderBody() {
    const { status, email } = this.state;

    if (status === 'loading') {
      return <p>Verifying user account...</p>;
    }

    if (status === 'success') {
      return (
        <>
          <h2>User verified</h2>
          <p>{email || 'The user'} has been successfully verified.</p>
          <p><Link to={appNavigation.login}>Go to login</Link></p>
        </>
      );
    }

    if (status === 'already') {
      return (
        <>
          <h2>Already verified</h2>
          <p>This user account is already verified.</p>
          <p><Link to={appNavigation.login}>Go to login</Link></p>
        </>
      );
    }

    if (status === 'expired') {
      return (
        <>
          <h2>Verification link expired</h2>
          <p>This admin verification link has expired. Please request a new admin verification link.</p>
          <p><Link to={appNavigation.login}>Go to login</Link></p>
        </>
      );
    }

    if (status === 'invalid') {
      return (
        <>
          <h2>Invalid verification link</h2>
          <p>The verification token or email is invalid.</p>
          <p><Link to={appNavigation.login}>Go to login</Link></p>
        </>
      );
    }

    return (
      <>
        <h2>Something went wrong</h2>
        <p>Could not verify user at this time. Please try again later.</p>
        <p><Link to={appNavigation.login}>Go to login</Link></p>
      </>
    );
  }

  render() {
    return (
      <div className="login-page">
        <div className="login-wrapper">
          <div className="login-form">
            {this.renderBody()}
          </div>
        </div>
      </div>
    );
  }
}

export default AdminVerifyUser;
